import { defineMessages } from "@/i18n";
import en from "./en";

export const layoutMessages = defineMessages("layout", en);
